import ContentLoading from "component/LoadingComponent/ContentLoading";
// import Divider from "component/divider/divider";
// import useExportToPDF from "component/htmlToPDF/export-html-pdf";
// import HtmlView from "component/htmlView/html-view";
import { API_BASE_URL } from "configs/AppConfig";
import { END_POINTS } from "constants/APIConstant";
// import { DateFormater } from "functions/dateTimeFormat";
import {
  useEffect,
  // , useRef
  useState,
} from "react";
import {
  // Button,
  Col,
  Container,
  Row,
  // Stack
} from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
// import { useParams } from "react-router-dom";
// import ForwardComponent from "svg-icons/forward-icon";
import useSWR from "swr";
// import { TRANSLATION_KEYS } from "constants/TranslationConstant";
import LabelLang from "component/LabelLang/label-lang"; // , { LabelLangString }
// import { useSelector } from "react-redux";
// import TreandingNewsCard from "pages/news/components/trendingNews/TreandingNewsCard";
import { TwitterTimelineEmbed } from "react-twitter-embed";
//import Socials from "component/WhatsNew/Socials/Socials";
import NewsBanner from "component/WhatsNew/NewsBanner/NewsBanner";
import InnerHeader from "component/shared/innerheader/InnerHeader";
// import SliderChart from "component/home/sliderChart/SliderChart";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css/navigation";
import "swiper/css";
import "./Whatsnew.scss";
import ServiceCard from "component/home/services/components/service-card";
import NewsCardItem from "component/home/newsVersion/components/news-card";
import MainButton from "component/shared/mainButton/MainButton";
// import Paginator from "component/shared/Paginator/Paginator";
import Publication from "component/shared/publication/Publication";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import ReactPlayer from "react-player";
import LineData from "./components/LineData";
import ReactGA from "react-ga4";
import { useSelector } from "react-redux";

const WhatsNew = () => {
  const intl = useIntl();

  const dir = useSelector(({ theme }) => theme.direction);

  var [newMedia, setNewMedia] = useState(0);

  useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, []);

  ReactGA.initialize(END_POINTS.TRACKING_ID);

  useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: "/new", title: "The new Page" });
  }, []);

  const SurveyCensuse = useSWR({
    url: END_POINTS.SURVEY_CENSUSE,
  });
  const SurveyCensuseData =
    SurveyCensuse.error ||
    SurveyCensuse.isLoading ||
    SurveyCensuse.data === undefined ||
    !SurveyCensuse.data.data
      ? []
      : SurveyCensuse.data.data.slice(0, 4);

  const importantPortal = useSWR({
    url: END_POINTS.IMPORTANT_PORTAL,
  });

  const ImportantPortalData = () => {
    const importantPortalData =
      importantPortal.error ||
      importantPortal.isLoading ||
      importantPortal.data === undefined ||
      !importantPortal.data.data
        ? []
        : importantPortal.data.data;

    const render =
      Object.keys(importantPortalData).length > 0 ? (
        importantPortalData.map(
          ({ title, link, importantPortalTranslations }, i) => (
            <li key={i}>
              <a id={title} href={link} style={{ color: "#000000" }}>
                <h5 style={{ padding: "14px", fontWeight: "400" }}>
                  <LabelLang
                    id="title"
                    defaultValue={title}
                    translations={importantPortalTranslations}
                  />
                </h5>
              </a>
              <center>
                <hr
                  style={{
                    borderWidth: "2px",
                    color: "#000000",
                    width: "95%",
                    opacity: "20%",
                  }}
                />
              </center>
            </li>
          )
        )
      ) : (
        <DataNotFound />
      );

    return render;
  };

  const latestNewsFetching = useSWR({
    url: END_POINTS.LATEST_NEWS,
  });
  const RenderLatestNews = () => {
    const newsData =
      latestNewsFetching.error ||
      latestNewsFetching.isLoading ||
      latestNewsFetching.data === undefined ||
      latestNewsFetching?.data?.data?.length <= 1
        ? []
        : latestNewsFetching.data?.data?.slice(0, 6);
    const render =
      Object.keys(newsData).length > 0 ? (
        newsData.map(
          (
            { id, title, brief, content, image, publishDate, newsTranslation },
            index
          ) => {
            return (
              <NewsCardItem
                key={index}
                image={image}
                title={title}
                description={brief}
                publicationDate={publishDate}
                translations={newsTranslation}
                id={id}
              />
            );
          }
        )
      ) : (
        <DataNotFound />
      );

    return render;
  };

  const defaultState = {
    pageSize: 2,
    currentPage: 1,
  };

  const publicationsFetching = useSWR({
    url: END_POINTS.PUBLICATIONS,
    params: defaultState,
  });
  const RenderPublications = () => {
    const publicationsData =
      publicationsFetching.error ||
      publicationsFetching.isLoading ||
      publicationsFetching.data === undefined ||
      publicationsFetching?.data?.data?.length <= 1
        ? []
        : publicationsFetching.data?.data;
    const rendering =
      Object.keys(publicationsData).length > 0 ? (
        publicationsData.map((item, i) => (
          <Publication key={i} item={item} isNew={true} />
        ))
      ) : (
        <DataNotFound />
      );
    return rendering;
  };

  const newToolsFetching = useSWR({
    url: END_POINTS.NEW_TOOLS,
  });
  const RenderNewTaps = () => {
    const renderData =
      newToolsFetching.error ||
      newToolsFetching.isLoading ||
      newToolsFetching.data === undefined ||
      newToolsFetching.data === null ||
      newToolsFetching?.data?.data?.length <= 1
        ? []
        : newToolsFetching.data?.data?.slice(0, 2);
    const rendering = renderData.map(
      (
        {
          id,
          title,
          shortDescription,
          link,
          isInternal,
          serviceAndToolTranslation,
          isSystem,
        },
        index
      ) => {
        return (
          <div key={index} className="col-md-6">
            <ServiceCard
              title={title}
              description={shortDescription}
              link={link}
              serviceAndToolTranslation={serviceAndToolTranslation}
              isInternal={isInternal}
              isSystem={isSystem}
              id={id}
            />
          </div>
        );
      }
    );
    return rendering;
  };

  const LatestPhoto = useSWR({
    url: END_POINTS.LATEST_PHOTO,
    // url: END_POINTS.PHOTO_ALBUM,
  });
  const photoAlbums =
    LatestPhoto.error ||
    LatestPhoto.isLoading ||
    LatestPhoto.data === undefined ||
    LatestPhoto.data === null
      ? []
      : LatestPhoto.data.data;

  const videosList = useSWR({
    // url: END_POINTS.VIDEO_LIBRARY,
    url: END_POINTS.LATEST_VIDEO,
  });
  const videos =
    videosList.error ||
    videosList.isLoading ||
    videosList.data === undefined ||
    videosList.data === null
      ? []
      : videosList.data.data;

  const dataChart = useSWR({
    url: END_POINTS.PINNED_INDICATORS,
  });

  const GetChartData = () => {
    const flattenedData = dataChart?.data?.data
      ? dataChart?.data?.data?.flatMap((item) => {
          return {
            ...item.indicator,
            publication: {
              id: item.id,
              name: item.name,
              publicationTranslations: item.publicationTranslations,
              yearType: item.yearType,
              periodic: item.periodic,
            },
          };
        })
      : [];
    return flattenedData;
  };

  return (
    <ContentLoading
      isLoading={
        SurveyCensuse.isLoading ||
        LatestPhoto.isLoading ||
        importantPortal.isLoading ||
        latestNewsFetching.isLoading ||
        publicationsFetching.isLoading ||
        newToolsFetching.isLoading ||
        dataChart.isLoading
      }
      className="news-details"
    >
      <InnerHeader
        breadcrumb={[
          {
            title: <FormattedMessage id="the-new" />,
            clickClass: true,
          },
        ]}
        title={intl.formatMessage({ id: "know-news" })}
      />
      <br />
      <br />
      <Container>
        <Row className="gx-lg-5">
          <Col xs={12} sm={12} md={12} lg={7} xl={8}>
            <div className="content-section">
              <NewsBanner />
            </div>

            <br />
            <hr
              style={{ borderWidth: "3px", color: "black", opacity: "100%" }}
            />

            <div>
              <h4 style={{ fontWeight: "bold" }}>
                <FormattedMessage id="the-new-in" />{" "}
                <FormattedMessage id="statistics" />
              </h4>
              <br></br>
              <div className="slider-chart-new mb-5">
                {!dataChart?.error &&
                !dataChart.isLoading &&
                GetChartData().length > 0 ? (
                  <Swiper
                    modules={[Navigation]}
                    navigation={{
                      prevEl: ".next",
                      nextEl: ".prev",
                    }}
                    spaceBetween={20}
                    slidesPerView={1}
                    dir="ltr"
                    loop
                  >
                    {/* <SwiperSlide>
                        {currentLocale == "en" ? (
                          <center>
                            <Container
                              style={{
                                border: "2px solid var(--main-color)",
                                borderRadius: "20px",
                              }}
                            >
                              <center>
                                <br></br>
                                <img
                                  //className="img1"
                                  src={
                                    process.env.PUBLIC_URL + "/image/whatsnew1.png"
                                  }
                                  alt="item-new"
                                  width="100%"
                                  loading="lazy"
                                />
                              </center>
                            </Container>
                          </center>
                        ) : (
                          <Container
                            style={{
                              border: "2px solid var(--main-color)",
                              borderRadius: "20px",
                            }}
                          >
                            <center>
                              <br></br>
                              <img
                                //className="img1"
                                src={
                                  process.env.PUBLIC_URL + "/image/whatsnew1.png"
                                }
                                alt="item-new"
                                width="100%"
                                loading="lazy"
                              />
                            </center>
                          </Container>
                        )}
                      </SwiperSlide>
                      <SwiperSlide>
                        <Container
                          style={{
                            border: "2px solid var(--main-color)",
                            borderRadius: "20px",
                          }}
                        >
                          <center>
                            <br></br>
                            <img
                              //className="img1"
                              src={process.env.PUBLIC_URL + "/image/whatsnew2.png"}
                              alt="item-new"
                              width="100%"
                              loading="lazy"
                            />
                          </center>
                        </Container>
                      </SwiperSlide> */}

                    {GetChartData()?.map((el, i) => (
                      <SwiperSlide key={i}>
                        <Container
                          style={{
                            border: "2px solid var(--main-color)",
                            borderRadius: "20px",
                            paddingTop: "1rem",
                          }}
                        >
                          <center>
                            <br></br>
                            <LineData data={el} publication={el?.publication} />
                          </center>
                        </Container>
                      </SwiperSlide>
                    ))}
                    <div className="prev">
                      <i className="fa fa-angle-left"></i>
                    </div>
                    <div className="next">
                      <i className="fa fa-angle-right"></i>
                    </div>
                  </Swiper>
                ) : (
                  <DataNotFound />
                )}
              </div>

              <div className="row">
                {RenderNewTaps() && Object.keys(RenderNewTaps()).length > 0
                  ? RenderNewTaps()
                  : // <DataNotFound />
                    ""}
                {/* <div className="col-md-6">
                  <ServiceCard
                    title="شارك في مسح إلكتروني"
                    description="المسح الإلكتروني الحالي: استخدام المصريين لوسائل التواصل الاجتماعي"
                    key="1"
                    link=""
                    isInternal={true}
                    serviceAndToolTranslation={[{
                      locale:'en',
                      title:"Participate in an electronic survey",
                      description:"Current online survey: Egyptians' use of social media"}
                    ]}
                  />
                </div>
                <div className="col-md-6">
                  <ServiceCard
                    title="اشترك في الرسائل الإخبارية"
                    description="اشترك في خدمة الرسائل الإخبارية لتصلك آخر مستجدات وإصدارات الجهاز شهرياً على بريدك الإلكتروني"
                    key="2"
                    link=""
                    isInternal={true}
                    serviceAndToolTranslation={[{
                      locale:'en',
                      title:"Subscribe to newsletters",
                      description:"Subscribe to the newsletter service to receive the latest developments and device releases monthly in your email"
                    }]}
                  />
                </div> */}
              </div>
            </div>

            <br />
            <hr
              style={{ borderWidth: "3px", color: "black", opacity: "100%" }}
            />

            <div>
              <h4 style={{ fontWeight: "bold" }}>
                <FormattedMessage id="the-new-in" /> ...
              </h4>
              <br />
              <div className="row">
                <div className="col-3">
                  <Container
                    role="button"
                    className="rounded-5 main-bg"
                    onClick={() => setNewMedia(0)}
                  >
                    <Row>
                      <img
                        className="img1"
                        src={process.env.PUBLIC_URL + "/image/sb.svg"}
                        alt="arrow"
                        loading="lazy"
                        height="100px"
                        style={{
                          transform:
                            dir === "rtl" ? "rotate(0deg)" : "rotate(90deg)",
                        }}
                      />
                    </Row>
                    <Row style={{ paddingBottom: "10px" }}>
                      <center>
                        <h4 style={{ color: "#FFFFFF" }}>
                          <FormattedMessage id="publications" />
                        </h4>
                      </center>
                    </Row>
                  </Container>
                </div>
                <div className="col-3">
                  <Container
                    role="button"
                    style={{ backgroundColor: "#0C42E1" }}
                    className="rounded-5"
                    onClick={() => setNewMedia(1)}
                  >
                    <Row>
                      <img
                        className="img1"
                        src={process.env.PUBLIC_URL + "/image/sb.svg"}
                        alt="arrow"
                        loading="lazy"
                        height="100px"
                        style={{
                          transform:
                            dir === "rtl" ? "rotate(0deg)" : "rotate(90deg)",
                        }}
                      />
                    </Row>
                    <Row style={{ paddingBottom: "10px" }}>
                      <center>
                        <h4 style={{ color: "#FFFFFF" }}>
                          <FormattedMessage id="theNews" />
                        </h4>
                      </center>
                    </Row>
                  </Container>
                </div>
                <div className="col-3">
                  <Container
                    role="button"
                    style={{ backgroundColor: "#761431" }}
                    className="rounded-5"
                    onClick={() => setNewMedia(2)}
                  >
                    <Row>
                      <img
                        className="img1"
                        src={process.env.PUBLIC_URL + "/image/sb.svg"}
                        alt="arrow"
                        loading="lazy"
                        height="100px"
                        style={{
                          transform:
                            dir === "rtl" ? "rotate(0deg)" : "rotate(90deg)",
                        }}
                      />
                    </Row>
                    <Row style={{ paddingBottom: "10px" }}>
                      <center>
                        <h4 style={{ color: "#FFFFFF" }}>
                          <FormattedMessage id="video" />
                        </h4>
                      </center>
                    </Row>
                  </Container>
                </div>
                <div className="col-3">
                  <Container
                    role="button"
                    className="rounded-5 second-bg"
                    onClick={() => setNewMedia(3)}
                  >
                    <Row>
                      <img
                        className="img1"
                        src={process.env.PUBLIC_URL + "/image/sb.svg"}
                        alt="arrow"
                        loading="lazy"
                        height="100px"
                        style={{
                          transform:
                            dir === "rtl" ? "rotate(0deg)" : "rotate(90deg)",
                        }}
                      />
                    </Row>
                    <Row style={{ paddingBottom: "10px" }}>
                      <center>
                        <h4 style={{ color: "#FFFFFF" }}>
                          <FormattedMessage id="photos" />
                        </h4>
                      </center>
                    </Row>
                  </Container>
                </div>
              </div>
              <br />
              <div>
                <div className="row">
                  <div className="col-3">
                    {newMedia == 0 && (
                      <center>
                        <img
                          className="img1"
                          src={process.env.PUBLIC_URL + "/image/pointer.png"}
                          alt="arrow"
                          loading="lazy"
                          height="25px"
                        />
                      </center>
                    )}
                  </div>
                  <div className="col-3">
                    {newMedia == 1 && (
                      <center>
                        <img
                          className="img1"
                          src={process.env.PUBLIC_URL + "/image/pointer.png"}
                          alt="arrow"
                          loading="lazy"
                          height="25px"
                        />
                      </center>
                    )}
                  </div>
                  <div className="col-3">
                    {newMedia == 2 && (
                      <center>
                        <img
                          className="img1"
                          src={process.env.PUBLIC_URL + "/image/pointer.png"}
                          alt="arrow"
                          loading="lazy"
                          height="25px"
                        />
                      </center>
                    )}
                  </div>
                  <div className="col-3">
                    {newMedia == 3 && (
                      <center>
                        <img
                          className="img1"
                          src={process.env.PUBLIC_URL + "/image/pointer.png"}
                          alt="arrow"
                          loading="lazy"
                          height="25px"
                        />
                      </center>
                    )}
                  </div>
                </div>
                {newMedia == 0 && (
                  <Container
                    style={{ backgroundColor: "#EBEBEB", height: "500" }}
                    className="whats-new-tab rounded-4 px-4 pb-3 pt-4"
                  >
                    <div className="row">
                      <RenderPublications />
                    </div>
                    <div className="row">
                      <label>
                        <br />
                      </label>
                      <div className="col-xl-9 col-md-8 col-sm-6 col-12"></div>
                      <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12">
                        <MainButton link={"publications"} text={"all-pubs"} />
                      </div>
                    </div>
                  </Container>
                )}
                {newMedia == 1 && (
                  <Container
                    style={{ backgroundColor: "#EBEBEB", height: "500" }}
                    className="whats-new-tab rounded-4 px-4 pb-3 pt-4"
                  >
                    <div className="row">
                      <RenderLatestNews />
                    </div>
                    <div className="row">
                      <label>
                        <br />
                      </label>
                      <div className="col-xl-9 col-md-8 col-sm-6 col-12"></div>
                      <div className="col-xl-3 col-lg-4 col-md-3 col-sm-6 col-12">
                        <MainButton
                          link={"./mediaLanding/news"}
                          text={"all-news"}
                          onClick={() => window.scrollTo(0, 0)}
                        />
                      </div>
                    </div>
                  </Container>
                )}
                {newMedia == 2 && (
                  //350
                  <Container
                    style={{ backgroundColor: "#EBEBEB" }}
                    className="whats-new-tab rounded-4 px-4 pb-3 pt-4"
                  >
                    <div>
                      {videos && Object.keys(videos).length > 0 ? (
                        <div className="row gx-md-3 gy-3 gy-md-0">
                          {/* <h2>
                            <br />
                          </h2> */}
                          <div className="col-12 col-md-6">
                            <ReactPlayer
                              url={
                                videos[0]?.url
                                  ? videos[0]?.url
                                  : "https://www.youtube.com/embed/9WLuF3vjj_U"
                              }
                              width={"100%"}
                              height={"100%"}
                            />
                            {/* <iframe
                              src="https://www.youtube.com/embed/eu92-trWHWI?si=6g_DO0GFhXfUk12l"
                              style={{ borderRadius: "20px" }}
                              width="100%"
                              height="100%"
                              allowFullScreen={true}
                            /> */}
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="row gx-md-3 gy-3">
                              {videos
                                .map(({ url }, i) => (
                                  <div key={i} className="col-12 col-md-6">
                                    <ReactPlayer
                                      url={
                                        url
                                          ? url
                                          : "https://www.youtube.com/embed/9WLuF3vjj_U"
                                      }
                                      width={"100%"}
                                      height={"100%"}
                                    />
                                  </div>
                                ))
                                .slice(1, 5)}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <DataNotFound />
                      )}

                      <div className="row">
                        <label>
                          <br />
                        </label>
                        <div className="col-xl-9 col-md-8 col-sm-6 col-12"></div>
                        <div className="col-xl-3 col-lg-4 col-md-3 col-sm-6 col-12">
                          <MainButton
                            link={"./mediaLanding/media#videos"}
                            text={"all-vids"}
                          />
                        </div>
                      </div>
                    </div>
                  </Container>
                )}
                {newMedia == 3 && (
                  //380
                  <Container
                    style={{ backgroundColor: "#EBEBEB" }}
                    className="whats-new-tab rounded-4 px-4 pb-3 pt-4"
                  >
                    <div>
                      {photoAlbums && Object.keys(photoAlbums).length > 0 ? (
                        <div className="row gx-md-3 gy-3 gy-md-0">
                          {/* <h2>
                            <br />
                          </h2> */}
                          <div className="col-12 col-md-6">
                            <img
                              src={
                                photoAlbums[0]?.thumbnail
                                  ? `${API_BASE_URL}/${photoAlbums[0]?.thumbnail}`
                                  : process.env.PUBLIC_URL + "/image/news1.png"
                              }
                              alt="arrow"
                              loading="lazy"
                              style={{ width: "100%", height: "100%" }}
                            />
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="row gx-md-3 gy-3">
                              {photoAlbums
                                .map(({ thumbnail }, i) => (
                                  <div key={i} className="col-12 col-md-6">
                                    <img
                                      src={
                                        thumbnail
                                          ? `${API_BASE_URL}/${thumbnail}`
                                          : process.env.PUBLIC_URL +
                                            "/image/news1.png"
                                      }
                                      alt="arrow"
                                      loading="lazy"
                                      style={{ width: "100%", height: "100%" }}
                                    />
                                  </div>
                                ))
                                .slice(1, 5)}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <DataNotFound />
                      )}

                      <div className="row">
                        <label>
                          <br />
                        </label>
                        <div className="col-xl-9 col-md-8 col-sm-6 col-12"></div>
                        <div className="col-xl-3 col-lg-4 col-md-3 col-sm-6 col-12">
                          <MainButton
                            link={"mediaLanding/media#albums"}
                            text={"all-images"}
                          />
                        </div>
                      </div>
                    </div>
                  </Container>
                )}
              </div>
            </div>

            <br />
            <hr
              style={{ borderWidth: "3px", color: "black", opacity: "100%" }}
            />

            {SurveyCensuseData && SurveyCensuseData?.length > 0 && (
              <div>
                <h4 style={{ fontWeight: "bold" }}>
                  <FormattedMessage id="censuses" />
                </h4>
                <br />
                <div className="row">
                  {SurveyCensuseData &&
                  Object.keys(SurveyCensuseData).length > 0 ? (
                    SurveyCensuseData.map((item, index) => (
                      <div key={index} className="col-3">
                        <Container role="button">
                          <a href={item?.link} style={{ color: "black" }}>
                            <Row>
                              <img
                                style={{
                                  borderColor: "var(--main-color)",
                                  borderWidth: 1.5,
                                }}
                                className="img1"
                                src={
                                  item?.imageUrl && item?.imageUrl != "string"
                                    ? `${API_BASE_URL}/${item.imageUrl}`
                                    : process.env.PUBLIC_URL + "/image/book.png"
                                }
                                // src={SurveyCensuseData[0]?.imageUrl}
                                alt="arrow"
                                loading="lazy"
                                height="150px"
                              />
                            </Row>
                            <Row style={{ paddingBottom: "10px" }}>
                              <center className="mt-3">
                                <h6>
                                  <LabelLang
                                    id="title"
                                    defaultValue={item?.title}
                                    translations={
                                      item?.surveyCensuseTranslations
                                    }
                                  />
                                </h6>
                                <h6>
                                  {item?.startYear}
                                  {item?.startYear != null &&
                                  item?.endYear != null ? (
                                    <>-</>
                                  ) : (
                                    <></>
                                  )}
                                  {item?.endYear}
                                </h6>
                              </center>
                            </Row>
                          </a>
                        </Container>
                      </div>
                    ))
                  ) : (
                    <DataNotFound />
                  )}
                </div>

                <br />
              </div>
            )}
          </Col>

          <Col xs={12} sm={12} md={12} lg={5} xl={4}>
            <div className="recommended-news-section">
              {/*FACEBOOK*/}
              {/* <div className="most-read">
                <ul>
                  <li>
                    <h4
                      className="header-title pe-3"
                      style={{ fontSize: "20px", fontWeight: "bold" }}
                    >
                      <FormattedMessage id="form-our-page-on" />{" "}
                      <FormattedMessage id="statistical-observatory" />
                    </h4>
                  </li>
                  <br></br>
                  <center>
                    <iframe
                      src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FCAPMASEG&tabs=timeline&width=350&height=499&small_header=false&adapt_container_width=true&hide_cover=true&show_facepile=true&appId"
                      width={350}
                      height={499}
                      style={{ border: "none", overflow: "hidden" }}
                      scrolling="no"
                      frameBorder={0}
                      allowFullScreen={true}
                      allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                    />
                  </center>
                </ul>
              </div> */}
              <div className="most-read">
                <ul>
                  <li>
                    <div className="row">
                      <div className="col-12 col-lg-9">
                        <h4
                          className="header-title pe-3"
                          style={{ fontSize: "8px", fontWeight: "bold" }}
                        >
                          <br></br>
                        </h4>
                        <h4
                          className="header-title pe-3"
                          style={{ fontSize: "20px", fontWeight: "bold" }}
                        >
                          <FormattedMessage id="form-our-page-on" />{" "}
                          <FormattedMessage id="facebook" />
                        </h4>
                      </div>
                      <div className="col-12 col-lg-3">
                        <img
                          width={60}
                          height={60}
                          src={`${process.env.PUBLIC_URL}/image/facebook.png`}
                          alt={"facebook-icon"}
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </li>
                  <br></br>
                  <center>
                    <iframe
                      src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FCAPMASEG&tabs=timeline&width=350&height=499&small_header=false&adapt_container_width=true&hide_cover=true&show_facepile=true&appId"
                      width={350}
                      height={499}
                      style={{ border: "none", overflow: "hidden" }}
                      scrolling="no"
                      frameBorder={0}
                      allowFullScreen={true}
                      allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                    />
                  </center>
                </ul>
              </div>
              {/* X */}
              <div className="most-read">
                <ul>
                  <li>
                    <div className="row">
                      <div className="col-12 col-lg-9">
                        <h4
                          className="header-title pe-3"
                          style={{ fontSize: "8px", fontWeight: "bold" }}
                        >
                          <br></br>
                        </h4>
                        <h4
                          className="header-title pe-3"
                          style={{ fontSize: "20px", fontWeight: "bold" }}
                        >
                          <FormattedMessage id="form-our-page-on" />{" "}
                          <FormattedMessage id="X" />
                        </h4>
                      </div>
                      <div className="col-12 col-lg-2">
                        <img
                          width={75}
                          height={75}
                          src={`${process.env.PUBLIC_URL}/icons/twitter-icon.png`}
                          alt={"twitter-icon"}
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </li>
                  <br></br>
                  <center>
                    <TwitterTimelineEmbed
                      sourceType="profile"
                      screenName="capmas_eg"
                      options={{
                        tweetLimit: "10",
                        width: "85%",
                        height: "500%",
                      }}
                      //theme="dark"
                      noHeader="true"
                      noBorders="true"
                      noFooter="true"
                    ></TwitterTimelineEmbed>

                    <div className="text-center fw-semibold">
                        <a href="https://x.com/capmas_eg" target="_blank" rel="noopener noreferrer">
                          <FormattedMessage id="follow-us-on" /> <FormattedMessage id="X" />
                        </a>
                    </div>
                  </center>
                </ul>
              </div>
              <div className="most-read">
                <div className="row">
                  <div className="col-12 col-lg-12">
                    <h4
                      className="header-title pe-3"
                      style={{ fontSize: "8px", fontWeight: "bold" }}
                    >
                      <br></br>
                    </h4>
                    <h4
                      className="header-title pe-3"
                      style={{ fontSize: "20px", fontWeight: "bold" }}
                    >
                      <FormattedMessage id="important-links" />
                    </h4>
                    <ul className="recommended-news-section whats-new">
                      <ImportantPortalData />
                    </ul>
                  </div>
                </div>
                <br></br>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </ContentLoading>
  );
};

export default WhatsNew;
